import { isNullOrUndefined } from 'src/app/validation';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomLoaderService } from 'src/app/services/custom-loader.service';
import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
import { ReportService } from 'src/app/services/report.service';
import { ExcelService } from '../../services/export/excel.service';
import * as html2pdf from 'html2pdf.js'
import { ProfileService } from 'src/app/services/profile.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PdfService } from 'src/app/services/export/pdf.service';
import pdfMake from './../../../assets/datatable/js/pdfmake.min.js';  //'pdfmake/build/pdfmake';
import pdfFonts from './../../../assets/datatable/js/vfs_fonts.js'; //'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
declare var $: any;

@Component({
  selector: 'app-earning-reports',
  templateUrl: './earning-reports.component.html',
  styleUrls: ['./earning-reports.component.scss']
})
export class EarningReportsComponent {
  Today: Date = new Date();
  IsMobile: boolean = false;
  G_ClientBasicInfoId: any;
  ReportName: string;
  RM_Name: string;
  PDFPrintPriview: boolean = false;
  G_UserType: number;
  G_UserID: string = '';
  UserID: string = '';
  G_ROLEID: string = ''
  IsShowBusinessMetric: boolean = false;
  MainActiveMenu: string = 'mf';
  SubActiveMenu: string = '';
  currentmenu: string = '';
  MonthsArray: string[] = [];
  YearsArray: string[] = [];
  isMultiSelect: boolean = false;
  isShowClientFilter: boolean = false;
  FilterType: string = 'byEmpSubroker';
  DDLFilterType: string = 'R';    //Added by Saddam
  DashboardUserId: string = '';
  DashboardUserRole: any = '';
  isChildSBSelected: boolean = false;
  isEmployeeSelected: boolean = false;
  isSubbrokerSelected: boolean = false;
  filteremp : string = "";
  filteredSBid: string = "";
  sumFilterMonth: string = "";
  sumFilterYear: string = "";
  ClientName: string;
  Address: string;
  SB_IFD_Name: string
  // Summary Report
  IFDSummaryReport: any[] = []
  IFDSummaryAccord: any[] = []
  pdfDetail : boolean = false
  ShowIFDSummaryReport: boolean = false
  // Detaile Report
  CurrentInvoiceNo: string = ""
  IFDDetailedReport: any[] = []
  IFDDetailedAccord: any[] = []
  ShowIFDDetailedReport: boolean = false
  ShowSummaryPdf = false;
  ShowDetailedPdf = false;
  EarningReportSummary : FormGroup;
  formsub : boolean = false;
  Base64Array: any = [];
  PdfPageHeight: number;
  PdfPageWidth: number;
  ShowHeaderFooter = false;
  FilterCheckBoxClicked: boolean;
  HiearchyId: any;
  FilterTypeValue: any ='';
  PlaceId: any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private EncrdecrService: EncrdecrService,
    private reportservice: ReportService,
    private Loader: CustomLoaderService,
    private ExcelService: ExcelService,
    private clientProfileService: ProfileService,
    private formBuilder: FormBuilder,
    private PdfService: PdfService) {
      this.EarningReportSummary = this.formBuilder.group({
        SummaryMnth : ['', Validators.required],
        SummaryYear : ['', Validators.required]
      })
     }


  ngOnInit() {
    this.BindFinancialYear()
    if (sessionStorage.getItem("HLIHOLK332") != undefined && sessionStorage.getItem("HLIHOLK332") != null) {
      let value = sessionStorage.getItem("HLIHOLK332")
      if (value == "FromReport") {
        //$('#ExpandCollapse').trigger('click');
        // $('.MainBg').addClass('collapsed_Menu');
        // $('.MainBg.collapsed_Menu').css('padding-left', '68px');
        $('.MainBg').addClass('collapsed_Menu');
      }
      // sessionStorage.removeItem("HLIHOLK332")
    }
    debugger
    let ut = sessionStorage.getItem('L2D3506kIHSk3E0');
    if (ut != null && ut != undefined && ut != "") {
      this.G_UserType = parseInt(this.EncrdecrService.getDecr(ut));
    }
    if (this.G_UserType == 1) {
      this.G_ROLEID = this.EncrdecrService.getDecr(sessionStorage.getItem('5gE4QWzFXWKewRC'));
    }
    if (!isNullOrUndefined(sessionStorage.getItem('F44sGAGh2xwkpUL'))) {
      this.G_UserID = this.EncrdecrService.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL'))
      if (this.G_UserType == 2) {
        this.filteredSBid = this.G_UserID
      }
    }
  }

  get sum() {
    return this.EarningReportSummary.controls;
  }


  ngAfterViewInit() {
    $(".classMonth").on("change", (e: any) => this.onMonthchange(e));
    $(".classYear").on("change", (e: any) => this.onYearchange(e));
  }
  // Binding the Financial Year and Months
  BindFinancialYear() {
    debugger
    const currentDate = new Date();
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
    this.MonthsArray = months
    // this.sumFilterMonth = "January"
    for (let index = 0; index < 3; index++) {
      this.YearsArray.push((currentDate.getFullYear() - index).toString())
    }
    // this.sumFilterYear = this.YearsArray[0]
  }

  // Filter the SB Id
  ClientFilterData(event) {
    debugger;
    // this.BindFinancialYear()
    console.log(event)
    if (event.ShowTransaction == false) {
      this.FilterTypeValue = event.FilterType;
      this.FilterCheckBoxClicked = true;
      this.isEmployeeSelected = false;
      this.isSubbrokerSelected = false;
      this.isChildSBSelected = false;
      this.ShowIFDSummaryReport = false
      this.ShowIFDDetailedReport = false;
      this.filteredSBid = null
      this.filteremp = null
      this.formsub = false
      this.pdfDetail = false
      this.EarningReportSummary.controls['SummaryYear'].setValue("")
      this.EarningReportSummary.controls['SummaryMnth'].setValue("")
      this.PlaceId = null;
      this.HiearchyId = null;
    } else {

      if (event.flag == "SubBroker") {
        this.filteredSBid = ""
        this.UserID = event.SubBrokerId;
        this.SB_IFD_Name = event.SubBrokerName;
        this.isSubbrokerSelected = true;
        if (event.SubBrokerId) {
          this.filteredSBid = event.SubBrokerId
        }
        if (event.IsChildSB == true) {
          this.isChildSBSelected = true;
        } else {
          this.isChildSBSelected = false;
        }
      } else if (event.flag == "employee") {
        this.filteredSBid = ""
        this.filteremp = ""
        this.UserID = event.EmployeId;
        this.RM_Name = event.EmployeeName
        this.SB_IFD_Name = '';
        console.log(this.UserID)
        this.isEmployeeSelected = true;
        this.isSubbrokerSelected = false;
        this.isChildSBSelected = false;
        if(event.EmployeId)
        {
          this.filteremp = event.EmployeId
          console.log(this.filteremp)
        }
      }
      else if (event.flag == "hiearchary"){
        this.filteredSBid = ""
        this.filteremp = ""
        this.HiearchyId = event.hierarchyId
        this.PlaceId = '';
      }
      else if (event.flag == "place")
      {
        this.filteredSBid = ""
        this.filteremp = ""
        this.PlaceId = event.placeId
      }


    }



  }
  // Summary Report
  tbnShowSummary() {
    debugger
    this.formsub = true;
    // this.BindClientHeaderData("Detailed")
    console.log(this.EarningReportSummary.get('SummaryMnth').value);
    console.log(this.EarningReportSummary.get('SummaryYear').value);
    console.log(this.sum.SummaryYear.errors)
    // if(this.filteremp)
    // {
      console.log("fliter"+this.filteremp)
    // }


    //Commented for testing
    if(this.FilterTypeValue == "byHierachy"){
      if(!isNullOrUndefined(this.HiearchyId)){
        if(!isNullOrUndefined(this.PlaceId)){
          if(!isNullOrUndefined(this.filteremp) )
    {
      if (!isNullOrUndefined(this.filteredSBid)) {
        debugger
        if(this.EarningReportSummary.valid)
        {
          console.log("form is valid")
          this.Loader.show()
          let JSONreq = {
            Subbrokerid: this.filteredSBid,
            Year: this.EarningReportSummary.get('SummaryYear').value,
            Month: this.EarningReportSummary.get('SummaryMnth').value
          }
          this.reportservice.GetIFDEarningReports(JSONreq).subscribe((res) => {
            debugger
            if (res) {
              let newres = this.EncrdecrService.getDecr(res)
              let neres = JSON.parse(newres)
              if (newres) {
                if (neres.ArrayOfResponse) {
                  this.IFDSummaryReport = neres.ArrayOfResponse
                  if (this.IFDSummaryReport.length > 0) {
                    this.IFDSummaryAccord = this.IFDSummaryReport.filter((item, index, array) => {
                      debugger
                      const isDuplicate = array.findIndex(x =>
                        x.Product === item.Product
                      ) === index;
                      return isDuplicate;
                    });
                    console.log("accord", this.IFDSummaryAccord)
                    this.DataTableFunc("Web")
                    this.Loader.hide()
                    this.ShowIFDSummaryReport = true
                  }
                  else {
                    this.Loader.hide()
                    this.CallAlertModal("No Record found!")
                    this.ShowIFDSummaryReport = false
                  }
                  // this.sumFilterMonth = ""
                  // this.sumFilterYear = ""
                }
                else {
                  this.Loader.hide()
                  this.CallAlertModal("No Record found!")
                  this.ShowIFDSummaryReport = false
                  // this.sumFilterMonth = ""
                  // this.sumFilterYear = ""
                }
              }
              else {
                this.Loader.hide()
                this.CallAlertModal("No Record found!")
                this.ShowIFDSummaryReport = false
                // this.sumFilterMonth = ""
                // this.sumFilterYear = ""
              }
            }
          })

        }
        else{
          console.log("form is invalid")
        }
      }
      else {
        this.Loader.hide()
        this.CallAlertModal("Please select Subbroker!")
        this.ShowIFDSummaryReport = false
        // this.formsub = false
      }
        }
        else
        {
          this.Loader.hide()
          this.CallAlertModal("Please select Employee!")
          this.ShowIFDSummaryReport = false
        }
        }
        else{
          this.Loader.hide()
          this.CallAlertModal("Please select Entity!")
          this.ShowIFDSummaryReport = false
        }
      }
      else{
        this.Loader.hide()
        this.CallAlertModal("Please select Hierarchy!")
        this.ShowIFDSummaryReport = false
      }
    }
    else{
      if(!isNullOrUndefined(this.filteremp) )
    {
      if (!isNullOrUndefined(this.filteredSBid)) {
        debugger
        if(this.EarningReportSummary.valid)
        {
          console.log("form is valid")
          this.Loader.show()
          let JSONreq = {
            Subbrokerid: this.filteredSBid,
            Year: this.EarningReportSummary.get('SummaryYear').value,
            Month: this.EarningReportSummary.get('SummaryMnth').value
          }
          this.reportservice.GetIFDEarningReports(JSONreq).subscribe((res) => {
            debugger
            if (res) {
              let newres = this.EncrdecrService.getDecr(res)
              let neres = JSON.parse(newres)
              if (newres) {
                if (neres.ArrayOfResponse) {
                  this.IFDSummaryReport = neres.ArrayOfResponse
                  if (this.IFDSummaryReport.length > 0) {
                    this.IFDSummaryAccord = this.IFDSummaryReport.filter((item, index, array) => {
                      debugger
                      const isDuplicate = array.findIndex(x =>
                        x.Product === item.Product
                      ) === index;
                      return isDuplicate;
                    });
                    console.log("accord", this.IFDSummaryAccord)
                    this.DataTableFunc("Web")
                    this.Loader.hide()
                    this.ShowIFDSummaryReport = true
                  }
                  else {
                    this.Loader.hide()
                    this.CallAlertModal("No Record found!")
                    this.ShowIFDSummaryReport = false
                  }
                  // this.sumFilterMonth = ""
                  // this.sumFilterYear = ""
                }
                else {
                  this.Loader.hide()
                  this.CallAlertModal("No Record found!")
                  this.ShowIFDSummaryReport = false
                  // this.sumFilterMonth = ""
                  // this.sumFilterYear = ""
                }
              }
              else {
                this.Loader.hide()
                this.CallAlertModal("No Record found!")
                this.ShowIFDSummaryReport = false
                // this.sumFilterMonth = ""
                // this.sumFilterYear = ""
              }
            }
          })

        }
        else{
          console.log("form is invalid")
        }


        // }

        // this.formsub = false
      }
      else {
        this.Loader.hide()
        this.CallAlertModal("Please select Subbroker!")
        this.ShowIFDSummaryReport = false
        // this.formsub = false
      }
        }
        else
        {
          this.Loader.hide()
          this.CallAlertModal("Please select Employee!")
          this.ShowIFDSummaryReport = false
        }
    }


  }
  // Filter data according to Product
  bindDataaccording(data: any, flag: any) {

    //console.log(data)
    let datanew = data.filter(r => r.Product == flag)
    let tempdata = datanew.map((element) => {
      element.InvoiceDate = element.InvoiceDate.slice(0, 10)
      if (element.InvoiceDate === '01/01/1900') {
        element.InvoiceDate = '';
      }
      //console.log("ele",element)
      return element
    })
    //console.log("temp", tempdata)
    return tempdata
  }
  // Sum of each Amount according to Product Summary
  GetAmountSum(data: any, flag: any) {
    let datanew = data.filter(r => r.Product == flag)
    const sumAge = datanew.reduce((preValue, currValue) => {
      preValue += Number(currValue.Total);
      return preValue;
    }, 0);
    return Number(sumAge).toFixed(2)
  }
  // Sum of each Amount according to Product Detailed
  GetAmountDetailed(data: any, flag: any) {
    let datanew = data.filter(r => r.Producttypecode == flag)
    const sumAge = datanew.reduce((preValue, currValue) => {
      preValue += Number(currValue.Amount);
      return preValue;
    }, 0);
    return Number(sumAge).toFixed(2)
  }
  // Detailed Report
  tblShowDetailed() {
    this.Loader.show()

    this.pdfDetail = true
    console.log(this.ShowIFDSummaryReport)
    console.log(this.ShowIFDDetailedReport)
    if (this.filteredSBid) {
      let JSONreq = {
        Subbrokerid: this.filteredSBid,
        Year: this.sumFilterYear,
        Month: this.sumFilterMonth,
        ChequeNo: this.CurrentInvoiceNo
      }
      this.reportservice.GetIFDEarningReportsDetailed(JSONreq).subscribe((res) => {
        if (res) {
          let newres = this.EncrdecrService.getDecr(res)
          let neres = JSON.parse(newres)
          if (neres) {
            if (neres.ArrayOfResponse) {
              if (neres.ArrayOfResponse.length > 0) {
                this.IFDDetailedReport = neres.ArrayOfResponse
                if (this.IFDDetailedReport.length > 0) {
                  this.IFDDetailedAccord = this.IFDDetailedReport.filter((item, index, array) => {
                    const isDuplicate = array.findIndex(x =>
                      x.Producttypecode === item.Producttypecode
                    ) === index;
                    return isDuplicate;
                  });
                }
                this.ExporttoExcelDetailed();
                // this.DataTableFuncDetailed()
                // this.ShowIFDDetailedReport = true
                this.Loader.hide()
              }
              else {
                this.Loader.hide()
                this.CallAlertModal("No Record found!")
                // this.ShowIFDDetailedReport = false
              }
            }
            else {
              this.Loader.hide()
              this.CallAlertModal("No Record found!")
              // this.ShowIFDDetailedReport = false
            }
          }
          else {
            this.Loader.hide()
            this.CallAlertModal("Something went wrong!")
            // this.ShowIFDDetailedReport = false
          }
        }
        else {
          this.Loader.hide()
          this.CallAlertModal("Something went wrong!")
          // this.ShowIFDDetailedReport = false
        }
      })
    }
    else {
      this.Loader.hide()
      this.CallAlertModal("Please select Subbroker!")
      // this.ShowIFDDetailedReport = false
    }
  }

  tabSummary()
  {
    console.log("summary tab")
    // this.ShowIFDDetailedReport = false
    // this.pdfDetail = false
  }

  tabDetailed()
  {
    console.log("detailed tab")
    if(!this.FilterCheckBoxClicked){
      this.ShowIFDDetailedReport = true
      this.pdfDetail = true
    }

  }


  // Filter data according to Product
  bindDetailedDataaccording(data: any, flag: any) {
    let datanew = data.filter(r => r.Producttypecode == flag)

    let tempdata = datanew.map((element) => {
      element.Date = element.Date.slice(0, 10)
      element.CHQ_NLeftDate = element.CHQ_NLeftDate.slice(0, 10)
      element.BrokFrmdate = element.BrokFrmdate.slice(0, 10)
      element.BrokToDate = element.BrokToDate.slice(0, 10)
      return element
    })

    return tempdata

  }
  //change Month
    onMonthchange(event: any) {
    this.EarningReportSummary.get('SummaryMnth').setValue(event.target.value);
  }

  // change Year
  onYearchange(event: any) {
    debugger
    console.log(event.target.value)
    this.EarningReportSummary.controls['SummaryYear'].setValue(event.target.value);
    // console.log("Summary Year value on change",this.EarningReportSummary.get('SummaryYear').value())
  }

  // Alert message
  CallAlertModal(msg: any) {
    $('#AlertModal').modal({ backdrop: 'static', keyboard: false });
    $('#AlertModalContent').text(msg);
  }
  // Invoice redirectional links
  SummaryToDetails(data: any) {
    debugger
    this.CurrentInvoiceNo = data
    if (data) {
      // document.getElementById("tabdetailed").click()
      this.pdfDetail = true
      this.tblShowDetailed()

    }
    else {
      this.CallAlertModal("No data found!")
    }
  }
  // PDF for Summary Report
  btnPDFSummary() {
    debugger
    let data: any = '';
    sessionStorage.setItem("sdkhlkj398", "/reports-new/earningreports")
    data = document.getElementById("accordion")
    let cbid = this.EncrdecrService.setEncr(`IFD Summary Report &*(!${this.G_ClientBasicInfoId}`)
    sessionStorage.setItem('pdfstring', `${data.innerHTML}#@3${cbid}`);
    this.router.navigate(['/reports-new/preview-pdf'], { relativeTo: this.route })
  }
  // PDF for Summary Report
  btnPDFDetailed() {
    let data: any = '';
    sessionStorage.setItem("sdkhlkj398", "/reports-new/earningreports")
    data = document.getElementById("accordion1")
    let cbid = this.EncrdecrService.setEncr(`IFD Summary Report &*(!${this.G_ClientBasicInfoId}`)
    sessionStorage.setItem('pdfstring', `${data.innerHTML}#@3${cbid}`);
    this.router.navigate(['/reports-new/preview-pdf'], { relativeTo: this.route })
  }
  // Go to Dashboard
  GoToDashboard() {
    this.router.navigate(['/reports-new/dashboard'], { relativeTo: this.route })
    $('.MainBg').removeClass('collapsed_Menu');
  }
  // DatatTable for the Summary
  DataTableFunc(Type) {
    debugger
    $('.dataTables').DataTable().destroy();
    $(".dataTables").DataTable().clear().draw();
    debugger
    $(document).ready(function () {
      debugger
      let Paging;
      let Searching;
      if (Type = "Web") {
        Paging = true;
        Searching = true;
      }
      else {
        Paging = false;
        Searching = false;
      }
      $('.dataTables').DataTable({
        searching: Searching,
        paging: Paging,
        // info: true,
        autoWidth: false
      })
    })
  }


  ExportToPdf_detail_new(Para) {
    debugger

    this.BindClientHeaderData(Para) //Added for testing
    let data: any = '';
    if (Para == "Summary") {
      //this.ShowSummaryPdf = true;
    }
    else {
      //this.ShowDetailedPdf = true;
    }

  }

  // Bind Header and Footer
  BindClientHeaderData(Para) {
    debugger
    this.Base64Array = [];
this.ShowHeaderFooter = true;
this.Loader.show()

    if (Para == "Summary") {
      this.ReportName = "IFD Summary Report"
    }
    else {
      this.ReportName = "IFD Detailed Report"
    }

      setTimeout(() => {
        debugger
        let time = new Date();
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0'); // Add leading zero if necessary
        const mmm = today.toLocaleString('default', { month: 'short' }); // Get month name (short format)
        const yyyy = today.getFullYear();

        const formattedDate = dd + '-' + mmm + '-' + yyyy;



        const FirstPage = document.getElementById("FirstPage_pdf") // summary Div

                let pageHeight = 0
                let pageWidth = 0
                let tableHeight = 0
                debugger
                  const element = document.getElementById('mainPdfContainer');
                  const sumdiv = document.getElementById("accordion_pdf") // summary Div
                  const sumtable = document.getElementById("tbnsumm_pdf") // summary Div
                  pageHeight = Math.max(sumdiv.clientHeight, sumtable.clientHeight,FirstPage.clientHeight)
                  pageWidth = Math.max(sumdiv.clientWidth, sumtable.clientWidth,FirstPage.clientWidth)


                if (pageHeight > 900) {
                  pageHeight = 900
                }
                else if(pageHeight < 900)
                {
                  pageHeight = 900
                }
                console.log("Table height: ", tableHeight)
                var opt = {
                  filename: this.ReportName,
                  image: { type: 'jpeg', quality: 5 },
                  html2canvas: { scale: 2, dpi: 192, },
                  jsPDF: { format: [pageHeight + 80, pageWidth + 80], unit: "px", orientation: 'landscape' },
                  pagebreak: {
                    after: '.FirstPage', before: '.datatable', avoid: ['.FirstPage'], mode: ['avoid-all', 'css', 'legacy'],
                  },
                  'margin': 10,
                  'autofit': {
                    'x': 'scale-to-fit',

                  }
                };


                html2pdf().from(element).set(opt).toPdf().get('pdf').then((pdf) => {
                  debugger
                  var totalPages = pdf.internal.getNumberOfPages();
                  for (let i = 1; i <= totalPages; i++) {
                    // set footer to every page
                    pdf.setPage(i);
                    // set footer font
                    pdf.setFontSize(8);
                    pdf.setTextColor(150);

                    const textWidth = pdf.internal.pageSize.getWidth(); // Get page width
                    const margin = 30; // Adjust margin as needed

                    pdf.setFontSize(12); // Adjust font size as needed

                    // Create left, center, and right content
                    // Create left, center, and right content
                    const leftContent = `Sub broker Name: ${this.SB_IFD_Name}`;
                    const centerContent = `Relationship Manager ${this.RM_Name}`; // Use actual data here
                    const rightContent = `Report as on: ${formattedDate}`;

                    // Calculate available space for non-center content
                    const nonCenterWidth = textWidth - 2 * margin; // Account for both left and right margins

                    // Calculate approximate width for left content (assuming fixed-length client name)
                    const leftWidth = Math.min(nonCenterWidth * 0.3, leftContent.length * pdf.getTextWidth(leftContent) / textWidth); // Adjust ratio as needed

                    // Calculate remaining space for center and right content
                    const remainingWidth = nonCenterWidth - leftWidth;

                    // Calculate approximate width for right content (assuming fixed-length "Report as on")
                    const rightWidth = Math.min(remainingWidth * 0.5, rightContent.length * pdf.getTextWidth(rightContent) / textWidth); // Adjust ratio as needed

                    // Calculate ideal center content width for perfect centering
                    const idealCenterWidth = remainingWidth - rightWidth;

                    // Calculate actual center content width based on font size limitations
                    const actualCenterWidth = Math.min(idealCenterWidth, centerContent.length * pdf.getTextWidth(centerContent) / textWidth);

                    // Calculate starting position for centered content
                    const centerX = margin + leftWidth + (idealCenterWidth - actualCenterWidth) / 2; // Center alignment adjustment

                    // Add footer text with calculated positions
                    pdf.text(margin, pdf.internal.pageSize.getHeight() - 10, leftContent, { align: 'left' });
                    pdf.text(centerX, pdf.internal.pageSize.getHeight() - 10, centerContent, { align: 'center' });
                    pdf.text(textWidth - margin - rightWidth, pdf.internal.pageSize.getHeight() - 10, rightContent, { align: 'right' });
                  }
                  this.Loader.hide()
                  this.ShowHeaderFooter = false;
                }).save();

      }, 1000);


  }

  // DataTable for the Detailed
  DataTableFuncDetailed() {
    $(".dataTables1").DataTable().clear().draw();
    $('.dataTables1').DataTable().destroy();
    $(document).ready(function () {
      $('.dataTables1').DataTable({
        searching: true,
        paging: true,
        info: true,
        autoWidth: false
      })
    })
  }
  // Export to Excel Summary
  ExporttoExcelSummary() {
    let ExcelWorkbookName = "IFD Summary Report";
    let ReportMainHeading = 'IFD Summary Report';
    let ExcelData = [];
    let ExcelName = [];
    let ExcelHeader = [];
    let MainHeading = [];
    let getfields = [];
    const selectedFields = ["Status", "Product", "InvoiceNo", "InvoiceDate", "" ,"ChequeNo", "ChequeDate", "GrossAmount", "GST", "Total", "RecoveryAmt", "TDS", "ChequeAmount"];

    for (let item = 0; item < this.IFDSummaryAccord.length; item++) {
      debugger
      getfields = this.IFDSummaryReport.filter(r => r.Product == this.IFDSummaryAccord[item].Product)
      getfields = getfields.map(obj => {
        // Create a new object with only the selected properties
        const newObj = {};
        let numStrArray = ["GrossAmount","Total","RecoveryAmt","ChequeAmount"]
        for (const field of selectedFields) {
          if(field === "")
          {
            newObj["BlankColumn"] = ""
          }
          else{
            if(numStrArray.includes(field)){
              newObj[field] = parseFloat(obj[field]);
            }
            else{
              newObj[field] = obj[field];
            }
          }
        }
        return newObj;
      });
      let data = []

      for (let index = 0; index < getfields.length; index++) {

          data.push(Object.values(getfields[index]))
      }
      ExcelData[item] = data
      ExcelName[item] = this.IFDSummaryAccord[item].Product;
      ExcelHeader[item] = [
        "Status",
        "Product Type",
        "Invoice No.",
        "Inv Date",
        "CN/DN No.",
        "Cheque/NEFT No.",
        "Cheque/NEFT Date",
        "Brokerage(Excl GST)(A)",
        "GST (B)",
        "Total Amt (A+B)(Rs.)",
        "Recovery Amt (Rs.)",
        "TDS (Rs.)",
        "Cheque/NEFT Amt (Rs.)"
      ]
    }
    this.ExcelService.generateMultipleTabInOneExcelSheet(ExcelWorkbookName, ReportMainHeading, MainHeading, ExcelName, ExcelHeader, ExcelData);
  }
  // Export to Excel Summary
  ExporttoExcelDetailed() {
    let ExcelWorkbookName = "IFD Detailed Report";
    let ReportMainHeading = 'IFD Detailed Report';
    let ExcelData = [];
    let ExcelName = [];
    let ExcelHeader = [];
    let MainHeading = [];
    let getfields = [];
    const selectedFields = [
      "ClientName",
      "Scheme",
      "TransType",
      "Date",
      "Amount",
      "FolioNo",
      "BrokerageRate",
      "BrokAmtTillDt",
      "AvgAssets",
      "PaidDays",
      "BrokType",
      "ChequeNo",
      "CHQ_NLeftDate",
      "BrokFrmdate",
      "BrokToDate"
    ];

    for (let item = 0; item < this.IFDDetailedAccord.length; item++) {

      getfields = this.IFDDetailedReport.filter(r => r.Producttypecode == this.IFDDetailedAccord[item].Producttypecode)
      debugger
      getfields.sort((a,b) => {
        if(a.ClientName < b.ClientName) return -1;
        if(a.ClientName > b.ClientName) return 1;
        return 0;
      })
      getfields = getfields.map(obj => {
        // Create a new object with only the selected properties
        const newObj = {};
        let numStrArray = ["Amount","BrokerageRate","BrokAmtTillDt","AvgAssets"];
        for (const field of selectedFields) {
          if(numStrArray.includes(field)){
            newObj[field] = parseFloat(obj[field]);
          }
          else{
            newObj[field] = obj[field];
          }
        }
        return newObj;
      });
      let data = []

      for (let index = 0; index < getfields.length; index++) {
          data.push(Object.values(getfields[index]))
      }
      ExcelData[item] = data
      ExcelName[item] = this.IFDDetailedAccord[item].Producttypecode;
      ExcelHeader[item] = [
        "Investor Name",
        "Scheme",
        "Txn type",
        "Investment Date",
        "Invest Amount (Rs.)",
        "Folio No/FDR no",
        "Brokerage Rate",
        "Brokerage Amt(Rs.)",
        "Avg Assets",
        "Paid Days",
        "Brokerage Type",
        "Cheque No/Ref no",
        "Cheque Date",
        "Brokerage From Date",
        "Brokerage to Date"
      ]
    }
    this.ExcelService.generateMultipleTabInOneExcelSheet(ExcelWorkbookName, ReportMainHeading, MainHeading, ExcelName, ExcelHeader, ExcelData);
  }

  GiveBase64(div_id,fileName,flag,content,Para)
  {
    let data = document.getElementById(div_id);
    let pageHeight = 900
    let pageWidth = 1000
    // pageHeight = Math.max(data.clientHeight)
    // pageWidth = Math.max(data.clientWidth)
    var opt = {
      filename: fileName,
      image: { type: 'jpeg', quality: 5 },
      html2canvas:  { scale: 1 },
      jsPDF: { format: [pageHeight, pageWidth ], unit: "px", orientation: 'landscape'},
       pagebreak: { mode:['avoid-all', 'css', 'legacy'] }
    };

      html2pdf().from(data).set(opt).outputPdf().then((pdf)=> {
        // This logs the base64 string
        debugger
        let pdfdata = "data:application/pdf;base64, "+btoa(pdf)

        this.Base64Array.push({'FileName':fileName,'Base64Content':pdfdata})

        if(flag == "first"){
          this.ReturnBase64FromPDF("", content, "");
        }
        else{
          let pdfDATA = {
            base64PDFLists:this.Base64Array,

          }
          this.reportservice.GeneratePDFFomBase64(pdfDATA).subscribe((res)=>{
            debugger
            this.ShowHeaderFooter = false;
            this.Loader.hide();
            let response = JSON.parse(this.EncrdecrService.getDecr(res))
             let Base64Data = response.ArrayOfResponse[0].Base64ZipFile;
            // let FileName = `BankCoveringLetter_${this.parseDateToDdmmyy(this.today)}`
            // this.downloadZip(Base64Data,FileName);
            let pdfdata = "data:application/pdf;base64, " + Base64Data
            //console.log(btoa(pdf))

              let DATA = pdfdata;
              const link = document.createElement("a")
              link.href = DATA;
              link.download = this.ReportName + ".pdf"
              link.click()
              link.remove()
          })
        }


      });


  }

  ReturnBase64FromPDF(PdfName, Content, ClientBasicInfoId) {
    //#region
    debugger
    let BaseString = '';
    let CompanyLogo = '';
    let TopImage = '';
    let BottomImage = '';


    //#endregion

    var dd = {
      //to view pdf in full view - eg: 'A0','A3','A4','LEGAL'
      pageSize: {
        width: 900,
        height:1000
      },
      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [10, 10, 10, 10],


      content: [
        Content
      ],


      styles: {
        header: {
          fontSize: 16,
          bold: true,
          margin: [0, 30, 0, 0],
          color: '#282828'
        },
        subheader: {
          fontSize: 13.5,
          bold: true,
          margin: [0, 10, 0, 0],
          color: '#282828'
        },
        ReportDate: {
          alignment: 'right',
          color: '#282828'
        },
        tableExample: {
          fontSize: 16,
          margin: [0, 5, 0, 5],
        },
        tableHeader: {
          fontSize: 16,
          bold: true
        },
      },
      defaultStyle: {
        //font : 'SegoeUI',
        fontSize: 9,
        color: '#434343'
      }
    }
    //#endregion
    let Base64Data = "";

    BaseString = pdfMake.createPdf(dd).getBase64((data) => {
      let pdfdata = "data:application/pdf;base64, " + data

      let DATA = pdfdata;
      Base64Data = DATA;

      this.Base64Array.push({'FileName':"MainContent",'Base64Content':Base64Data})

      this.GiveBase64("LastPage","footer","last","","");

    });
  }


}
